import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import { rootReducer } from './reducers'
import { render } from '@testing-library/react'
import { Provider } from 'react-redux'

const middlewares = [thunk]
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middlewares)))

export const renderWithProvider = (
  Component,
  options?: { props?: object; preloadedState?: object }
) => {
  return render(
    <Provider
      store={createStore(
        rootReducer,
        options?.preloadedState,
        composeWithDevTools(applyMiddleware(...middlewares))
      )}
    >
      <Component {...options?.props} />
    </Provider>
  )
}

export const isUserLoggedIn = () => store.getState()?.user?.isLoggedIn
export const getOwnTennisId = () => store.getState()?.user?.tennisId

export default store
